import React, {
    InputHTMLAttributes,
    useContext,
    useEffect,
    useState,
} from "react";

import { BsFillTrashFill } from "react-icons/bs";
import AdminUserContext from "../../context/AdminUser";
import { SubmitButton } from "../../Korbantech/components/Buttons/SubmitButton";
import { Select } from "../../Korbantech/components/Inputs/Select";
import TextareaInput from "../../Korbantech/components/Inputs/TextareaInput";
import { TextInput } from "../../Korbantech/components/Inputs/TextInput";
import { Label } from "../../Korbantech/components/Label";
import { Question } from "../../types/Question";
import { Trail } from "../../types/Trail";
import { CheckItem } from "../CheckItem";
import { AlternativesFields } from "./AlternativesFields";

export const QuestionFields = ({
    remove,
    trails,
    last,
    newQuestion,
    question,
    ...props
}: Props) => {
    const [currentTrails, setCurrenTrails] = useState<TrailHelper[]>([]);
    const [isMultiple, setIsMultiple] = useState<boolean>(
        question?.multiple ? question.multiple : false
    );
    const [isImportant, setIsImportant] = useState<boolean>(
        question?.important ? question.important : false
    );
    const [selectedTrail, setSelectTrail] = useState<string>();
    const { state: user } = useContext(AdminUserContext);

    useEffect(() => {
        if (trails) setCurrenTrails(trails);
        if (question?.trail) setSelectTrail(question.trail.id);
    }, [trails, question]);

    return (
        <div className="rounded border flex flex-col border-gray-600 bg-white p-6 my-2">
            <Label>
                <div className="flex justify-between items-center w-full">
                    <div className="text-lg font-semibold">Questão</div>
                    {remove && (
                        <div className="text-xl">
                            <BsFillTrashFill onClick={remove} />
                        </div>
                    )}
                </div>
                <TextareaInput
                    required
                    name={`questions[${props.name}][question]`}
                    rows='7'
                    defaultValue={question && question.question}
                    className={
                        "bg-gray-200 rounded border border-gray-600 text-gray-700 my-2 h-48"
                    }
                />
            </Label>
            <Label>
                <div className="text-md font-semibold">Trilha</div>
                <div className="w-full grid grid-cols-4 gap-x-3">
                    <div className="col-span-3">
                        <Select
                            selectLabel={
                                selectedTrail ? selectedTrail : "Trilha"
                            }
                            selected={selectedTrail}
                            options={currentTrails?.map((c) => ({
                                label: c.name,
                                value: c.id,
                            }))}
                            onChange={(opt) => setSelectTrail(opt.value)}
                        />
                    </div>
                    {question && user?.is_super_admin && (
                        <div className="w-full">
                            <button
                                type="button"
                                onClick={()=>setSelectTrail(undefined)}
                                className="bg-red-500 text-white h-full w-full rounded-md"
                            >
                                Remover Trilha
                            </button>
                        </div>
                    )}
                </div>
            </Label>
            <input
                hidden
                name={`questions[${props.name}][trail]`}
                defaultValue={selectedTrail}
            />
            <div className="flex gap-x-1">
                <div className="my-3 border-2 border-r-2  border-gray-300 rounded-md p-1 ">
                    <CheckItem
                        type="radio"
                        name={`questions[${props.name}][multiple]`}
                        defaultValue={isMultiple ? 1 : 0}
                        defaultChecked={isMultiple}
                        label="Multipla escolha"
                        onClick={() =>
                            setIsMultiple((prev) => (prev ? false : true))
                        }
                    />
                </div>
                <div className="my-3 border-2 border-r-2  border-gray-300 rounded-md p-1  ">
                    <CheckItem
                        type="radio"
                        name={`questions[${props.name}][important]`}
                        defaultValue={isImportant ? 1 : 0}
                        defaultChecked={isImportant}
                        label="Importante"
                        onClick={() =>
                            setIsImportant((prev) => (prev ? false : true))
                        }
                    />
                </div>
            </div>
            <Label className="w-2/12">
                <div className="text-lg font-semibold ">Posição</div>
                <TextInput
                    min="0"
                    required
                    type="number"
                    name={`questions[${props.name}][position]`}
                    defaultValue={question && question.position}
                    className={
                        "bg-gray-200 rounded border border-gray-600 text-gray-700 my-2"
                    }
                />
            </Label>
            <Label>
                <div className="text-lg font-semibold">Exemplo</div>
                <TextInput
                    name={`questions[${props.name}][hint]`}
                    defaultValue={question && question.hint}
                    className={
                        "bg-gray-200 rounded border border-gray-600 text-gray-700 my-2"
                    }
                />
            </Label>
            <AlternativesFields
                alternatives={question?.alternatives}
                name={props.name}
            />
            {question && user?.is_super_admin ? (
                <div className="w-full flex justify-between">
                    {/* <div className='w-5/12 self-end mt-4'>
                    <button className='bg-red-500 text-white py-1 px-4 rounded-md'>
                        Deletar Questão
                    </button>
                </div> */}
                    <div className="w-5/12 self-end mt-4">
                        <SubmitButton value="Alterar questão" />
                    </div>
                </div>
            ) : (
                ""
            )}
            {newQuestion && user?.is_super_admin && (
                <div className="w-5/12 self-end mt-4">
                    <SubmitButton value="Alterar questão" />
                </div>
            )}
        </div>
    );
};

interface TrailHelper extends Trail {
    checked?: boolean;
}

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    last?: boolean;
    remove?: () => void | undefined;
    question?: Question;
    newQuestion?: boolean;
    trails?: Trail[];
}
